export const DEFAULT_MARGIN = 16;
export const TEXT_FONT = 'var(--font-work-sans)';

export const MODALS_DEFAULT_Z_INDEX = 200;
